import React, { useEffect, useState } from "react";
import bem from 'utils/bem';
import { Formik } from 'formik';
import validationSchema from './validationSchema';
import Form from './Form';
import './index.sass'
import Model from '../../../../model';
import { toast } from 'react-hot-toast';
import OfficeOrderPaySuccess from './OfficeOrderPaySuccess';
import { getCustomerPrice } from 'api/user';

const initialValues = {
    paymentSystem: 'A',
    saleSum: 0
};

const { block, el } = bem('certificate-form');

const OfficePayForm = ({service, visits, ticketId, orderId}) => {
    const [ submitSuccess, setSubmitSuccess ] = useState(false);

    const { username } = Model.user;
    const [ loading, setLoading ] = useState(false);
    const [ price, setPrice ] = useState(Infinity);

    useEffect(() => {
        if ( service && visits ) {
            setLoading(true);
            getCustomerPrice({service, visits, phone: username}).then((price) => {
                setLoading(false);
                setPrice(price);
            })
        }
    }, [service, visits])


    const handleSubmit = (values) => {
        const formData = new FormData();

        if (ticketId) {
            formData.append('ticket_id', ticketId);
        }
        if (orderId) {
            formData.append('order_id', orderId);
        }

        formData.append('sale_sum', values.saleSum);

        let url = '/order/pay_order';
        if (ticketId) {
            url = '/ticket/pay_ticket'
        }

        fetch(url, {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            const error = response?.error;
            if (error === 'paid')
                toast.error('Заказ уже оплачен');
            else if (error) {
                toast.error(`Произошла ошибка, пожалуйста, обратитесь к администратору: ${error}`);
            } else {
                if (response.success && response.redirect) {
                    window.location.href = response.redirect;
                } else if (response.success && response.redirect === undefined) {
                    setSubmitSuccess(true);
                }
            }
        });
    }

    const title = 'Оплата консультации';

    if (submitSuccess) {
        return <OfficeOrderPaySuccess />
    }

    return <div className={block()}>
        <Formik
            initialValues={initialValues}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}>
            {props => <Form {...props} price={price} title={title}/>}
        </Formik>
    </div>
};

export default OfficePayForm;
